
import { FIELD_LABELS, EVALUE } from "./consts";



export default class QueryHelper{

    query_data: { [key: string]: { min: { value: any, enabled: boolean }, max: { value: any, enabled: boolean } } };

    constructor(clone?:undefined | QueryHelper) {

        if (clone === undefined) {
            this.query_data = {};
            this.generateQueryData();            
        } else {            
            this.query_data = JSON.parse(JSON.stringify(clone.getQuery()));
        }

    }

    generateQueryData() {
        Object.keys(FIELD_LABELS).forEach(key =>
            this.query_data[key] = {
                min:
                    { value: undefined, enabled: false },
                max: { value: undefined, enabled: false }
            }
        );

        (this.query_data as any).modes = [];
        (this.query_data as any).methods = [];

    }

    setMM(field: string, value: any) {
        this.query_data[field] = value;
    }

    setQueryValue(field: string, evalue: EVALUE, value: any) {
        this.query_data[field][evalue].value = value;
    }

    setQueryEnabled(field: string, evalue: EVALUE, enabled: boolean) {
        this.query_data[field][evalue].enabled = enabled;
    }

    getQueryValue(field: string, evalue: EVALUE) {
        return this.query_data[field][evalue].value;
    }

    getQueryEnabled(field: string, evalue: EVALUE) {
        return this.query_data[field][evalue].enabled;
    }


    getQuery() {
        return this.query_data;
    }

}


